<template>
    <VJoyButton
        variant="primary"
        size="xsmall"
        :label="$t('profile.vetting.drawer.save')"
        data-testid="vetting-edition-save-button"
        @click="profileQualificationStore.saveProfileQualification()"
    />
</template>

<script setup lang="ts">
    import {VJoyButton} from '@maltjoy/core-vue';
    import {useProfileQualificationStore} from '~/store/profileQualificationStore';

    const profileQualificationStore = useProfileQualificationStore();
</script>
